import { useState } from "react";
import { useToast } from './ToastContext'; 

function ContactForm() {

    const [fullName, setFullName] = useState("");
    const [description, setDescription] = useState("");
    const {showMessage,showLoading } = useToast();

    const handleSubmit = async () => {

    const loadingToastId = showLoading("در حال انجام عملیات...");
    const formData = new FormData();
        formData.append("fullName", fullName);
        formData.append("comment", description);
        formData.append("gSubmitForm", 1);
        formData.append("id_shop", 1);
        formData.append("id_lang", 1);
        formData.append("idform", 2);
        formData.append("usingajax",1);
        
        try {
            const response = await fetch(`${global.config.domain_url}/form/-g2.html`, {
                method: "POST",
                body: formData,
            });
            const data = await response.json();
           
            if (data.errors=='0') {
                showMessage('success', "عملیات موفقیت‌آمیز بود!", 3000, loadingToastId);
                setFullName(""); // پاک کردن فیلد نام
                setDescription(""); // پاک کردن فیلد توضیحات
            } else {
                showMessage('error',`خطا ${data.errors}`, 3000, loadingToastId);
               
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            showMessage('error', 'ارسال فرم با مشکل مواجه شد.', 3000, loadingToastId);
            
        }
    };
    return(
        <>

        <div className="contact-form container">

            <h4>ثبت شکایات</h4>

            <div className="right-contact-form col-lg-6 col-12">
                <label>نام و نام خانوادگی (اختیاری)</label>
                <input  className="form-input col-12"
                    type="text"
                    placeholder="نام و نام خانوادگی"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)} 
                />
            </div>
            <div className="left-contact-form col-lg-6 col-12">
                <label>توضیحات</label>
                <textarea  className="form-input col-12"
                    placeholder="توضیحات"
                    rows={4}
                    cols={50}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                ></textarea><br></br>
                <button className="submit-form-btn border-0" onClick={handleSubmit}>ارسال</button>
            </div>

        </div>
       
        </>
    );

}

export default ContactForm;